module.exports = __webpack_public_path__ + "media/images/iconPaginateFirst--dark-5a374b4bc73aedf41aefb13c79a74e0e.png";